import t from "../component-transformers/navigation-menu-transformer/navigationMenuTransformer.js";
import m from "../component-transformers/site-navigation-transformer/siteNavigationTransformer.js";
import n from "../component-transformers/default-transformer/defaultTransformer.js";
import a from "../component-transformers/footer-transformer/footerTransformer.js";
import e from "../component-transformers/journey-timelines-transformer/journey-timelines-transformer.js";
import i from "../component-transformers/hero-component-transformer/hero-component-transformer.js";
import s from "../component-transformers/sitelogo-transformer/sitelogo-transformer.js";
import f from "../component-transformers/faq-groups-transformer/faqGroupsTransformer.js";
import p from "../component-transformers/news-timelines-transformer/news-timelines-transformer.js";
import _ from "../component-transformers/rich-text-component-transformer/richTextComponentTransformer.js";
import c from "../component-transformers/quick-links-design-one-transformer/quickLinksDesignOneTransformer.js";
import d from "../component-transformers/quick-links-design-two-transformer/quickLinksDesignTwoTransformer.js";
import l from "../component-transformers/hero-banner-transformer/hero-banner-transformer.js";
import u from "../component-transformers/awards-timelines-transformer/awards-timelines-transformer.js";
import g from "../component-transformers/about-amway-brands-transformer/about-amway-brands-transformer.js";
import y from "../component-transformers/steps-to-business-owner-transformer/steps-to-business-owner-transformer.js";
import w from "../component-transformers/download-link-transformer/download-link-transformer.js";
import C from "../component-transformers/amway-highlights-transformer/amway-highlights-transformer.js";
import h from "../component-transformers/amway-business-link-transformer/amway-business-link-transformer.js";
import T from "../component-transformers/banner-rich-text-transformer/banner-rich-text-transformer.js";
import A from "../component-transformers/meet-our-people-transformer/meet-our-people-transformer.js";
import b from "../component-transformers/our-promises-transformer/our-promises-transformer.js";
import k from "../component-transformers/shop-by-category-transformers/shopByCategoryTransformer.js";
import v from "../component-transformers/notification-transformer/notification-transformer.js";
import x from "../component-transformers/shop-by-container-transformer/shop-by-container-transformer.js";
import B from "../component-transformers/featured-card-container-transformer/featuredCardsTransformer.js";
import O from "../component-transformers/video-banner-transformer/video-banner-transformer.js";
import q from "../component-transformers/featured-article-carousal-transformer/featured-article-carousal-transformer.js";
import S from "../component-transformers/my-account-container-transformer/my-account-container-transformer.js";
import D from "../component-transformers/featured-card-container-transformer/featured-display-card-transformer.js";
import L from "../component-transformers/content-card-transformer/content-card-transformer.js";
import o from "../component-transformers/content-card-carousel-transformer/content-card-carousel-transformer.js";
import N from "../component-transformers/article-card-transformer/article-card-transformer.js";
import F from "../component-transformers/promotion-card-transformer/promotion-card-transformer.js";
import H from "../component-transformers/resource-card-transformer/resource-card-transformer.js";
import { transformHighlightsC as I } from "../component-transformers/highlightsC-transformer/highlightsC-transformer.js";
import P from "../component-transformers/standard-banner-no-cta-transformer/standard-banner-no-cta-transformer.js";
import R from "../component-transformers/article-overview-transformer/article-overview-transformer.js";
import G from "../component-transformers/video-section-transformer/video-section-transformer.js";
import M from "../component-transformers/faq-transformer/faqTransformer.js";
import V from "../component-transformers/text-only-transformer/text-only-transformer.js";
import Q from "../component-transformers/imageWithOptionalCTA-transformer/imageWithOptionalCTA-transformer.js";
import j from "../component-transformers/audioplayer-transformer/audioplayer-transformer.js";
import J from "../component-transformers/ImageAndText-transformer/ImageAndText-transformer.js";
import W from "../component-transformers/grid-view-image-gallery-transformer/grid-view-image-gallery-transformer.js";
import z from "../component-transformers/accordion-component-transformer/accordion-component-transformer.js";
import E from "../component-transformers/table-component-transformer/table-component-transformer.js";
import { ComponentType as r } from "./types/propTypes.js";
const Qr = {
  [r.table_component]: E,
  [r.accordion_component]: z,
  [r.image_and_text]: J,
  [r.grid_view_image_gallery]: W,
  [r.audio_player]: j,
  [r.text_only]: V,
  [r.image_with_optional_cta]: Q,
  [r.mega_menu]: t,
  [r.top_navigation]: m,
  [r.default]: n,
  [r.footer]: a,
  [r.journey_timelines]: e,
  [r.hero_component]: i,
  [r.site_logo]: s,
  [r.faq_groups]: f,
  [r.faq]: M,
  [r.news_timelines]: p,
  [r.rich_text_component]: _,
  [r.quick_links_design_one]: c,
  [r.quick_links_design_two]: d,
  [r.hero_banner]: l,
  [r.awards_timelines]: u,
  [r.about_amway_brands]: g,
  [r.amway_highlights]: C,
  [r.steps_to_business_owner]: y,
  [r.download_links]: w,
  [r.amway_business_links]: h,
  [r.banner_rich_text_component]: T,
  [r.amway_promises]: b,
  [r.meet_our_scientists]: A,
  [r.featured_cards]: k,
  [r.notification]: v,
  [r.shop_by_container]: x,
  [r.featured_card_container]: B,
  [r.video_banner]: O,
  [r.featured_articles_carousal]: q,
  [r.my_account_container]: S,
  [r.featured_display_card]: D,
  [r.content_card]: L,
  [r.content_card_carousal]: o,
  [r.article_carousel]: o,
  [r.promotion_carousel]: o,
  [r.resource_carousel]: o,
  [r.resource_card]: H,
  [r.article_card]: N,
  [r.promotion_card]: F,
  [r.highlights_c]: I,
  [r.standard_banner_no_cta]: P,
  [r.article_overview]: R,
  [r.video_section]: G
};
export {
  Qr as default
};
//# sourceMappingURL=componentTransformerRegistry.js.map
